import { render, staticRenderFns } from "./WithdrawTabTable.vue?vue&type=template&id=52716fb4"
import script from "./WithdrawTabTable.vue?vue&type=script&lang=js"
export * from "./WithdrawTabTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports